import { createGetPropGetter } from '@/store/utils';

export default {
  notifications: createGetPropGetter('notifications', []),
  unreadNotifications: createGetPropGetter('unreadNotifications', []),
  notificationListOptions: createGetPropGetter('notificationListOptions', {}),
  notificationsListSort(state, { notificationListOptions = {} }) {
    return notificationListOptions.sort || {};
  },
};
